import { useBild } from '../lib/bild'
import type { Mensch } from '../lib/warteschlangen'

/**
 * An jedem Vorgang steht der Mensch: Name, Bild, Punktestand — und die Zahl
 * der bisher abgelehnten Beiträge, weil das die Zahl ist, die eine
 * Entscheidung wirklich trägt (§8.1).
 *
 * Bei anonymen Konten steht „Anonym" plus die gekürzte UID. **Es wird nichts
 * erfunden**: ein Platzhaltername wäre eine Behauptung über einen Menschen.
 */
export default function MenschKarte({
  mensch,
  uid,
}: {
  mensch: Mensch | null
  uid: string | null
}) {
  if (!mensch) {
    return (
      <div className="mensch">
        <div className="mensch-bild mensch-bild-leer" aria-hidden="true" />
        <div>
          <p>{uid ? `Anonym · ${uid.slice(0, 6)}` : 'Unbekannt'}</p>
          <p className="leise">
            {uid ? 'kein Konto in core_app_user' : 'kein Konto verknüpft'}
          </p>
        </div>
      </div>
    )
  }

  const name =
    mensch.username ??
    mensch.display_name ??
    `Anonym · ${mensch.firebase_uid.slice(0, 6)}`

  return (
    <div className="mensch">
      <Profilbild klein={mensch.profilbild_klein} original={mensch.profilbild} />
      <div className="mensch-text">
        <p className="mensch-name">{name}</p>
        <p className="gedaempft mensch-zahlen">
          <span className="zahl">{mensch.points}</span> Punkte ·{' '}
          <span className="zahl">{mensch.bewertungen}</span> Bewertungen ·{' '}
          <span className="zahl">{mensch.fotos}</span> Fotos
          {/* Nur wenn es bekannt ist. Wer aus der 1.0 kommt, hat kein Gerät
              gemeldet — „Push aus" wäre dort eine Behauptung. */}
          {mensch.push === true && ' · Push an'}
          {mensch.push === false && ' · Push aus'}
        </p>
        <p className={mensch.abgelehnt > 0 ? 'mensch-abgelehnt' : 'leise'}>
          <span className="zahl">{mensch.abgelehnt}</span>{' '}
          {mensch.abgelehnt === 1 ? 'Beitrag' : 'Beiträge'} bisher abgelehnt
          {mensch.is_anonymous && ' · anonymes Konto'}
        </p>
      </div>
    </div>
  )
}

/**
 * Erst die 400er-Variante, sonst das Original — das Bild ist ein Kreis von
 * 48 Pixeln, das Original bis zu 1,5 MB groß. Die Variante kann trotz Eintrag
 * in `variants` fehlen; sie entsteht asynchron nach dem Upload.
 */
function Profilbild({
  klein,
  original,
}: {
  klein: string | null
  original: string | null
}) {
  const zustand = useBild(klein ?? original, original)

  if (zustand.art !== 'da') {
    return <div className="mensch-bild mensch-bild-leer" aria-hidden="true" />
  }
  return <img className="mensch-bild" src={zustand.adresse} alt="" />
}
